import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';
import { loadC2CConf } from '../api';
import { C2CConfig, UrlParams } from '../types';
import { i18n } from '../i18n';
import { getUrlParamByKey } from './url-params-helper';

export * from './act';
export * from './share';

/**
 * 拉取 C2C 配置
 * @param campaignId 扫码有礼计划 ID
 */
export async function loadC2CConfByCampaignId(campaignId: string): Promise<C2CConfig | null> {
  if (!campaignId) return null;
  const config = await loadC2CConf();
  for (const conf of config) {
    if (conf.actInfo.campaignId === campaignId) {
      return conf;
    }
  }
  return null;
}

/** 链接上是否带上 C2C 分享码 */
export function getUrlHasC2CShareCode() {
  return getUrlParamByKey(UrlParams.c2cShareCode);
}

/** 是否展示 C2C 弹窗 */
export function isShowC2CDialog() {
  return !!Number(getUrlParamByKey(UrlParams.showC2CDialog));
}

/** C2C是否在活动中 */
export function getIsC2CInActTime(config: C2CConfig): boolean {
  const { startTime, endTime } = config.actInfo;
  const serverTime = getServerTime();
  return dayjs(serverTime).isAfter(dayjs(startTime)) && dayjs(serverTime).isBefore(dayjs(endTime));
}

/** 是否展示活动已结束提示 */
export function getIsShowActEndTips(config: C2CConfig, shareCode: string): boolean {
  const { endTime } = config.actInfo;
  const serverTime = getServerTime();
  return dayjs(serverTime).isAfter(endTime) && !!shareCode;
}

/** 是否空昵称 */
export function isEmptyNickName(nickName: string) {
  // 后台对 none 也做了掩码，这里也把 no** 认为是空的
  return !nickName || nickName === 'none' || nickName === 'no**';
}

/** 格式化昵称 */
export function formatNickName(nickName: string) {
  return isEmptyNickName(nickName) ? i18n('好友') : nickName;
}
